import React, { useState } from "react";

import { toast } from "react-toastify";
import { useMutation } from "react-query";

import { updateEmployeRequests } from "../../../../../MyApi/hr/employerequests";

import icons from "../../../../../Data/icons";

import classes from "./attachModal.module.css";

const StatusModal = ({ closeModal, id ,refetch }) => {
  const [statusSelected, setStatus] = useState("");
  const [note, setNote] = useState("");

  const mutation = useMutation(
    "updateEmploymentRequestStatus",
    (postData) => updateEmployeRequests(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        closeModal()
        refetch()
      },
      onError: (error) => {
        toast.error(`(${error.response.data.message}`);
      },
    }
  );
  const handlePostRequest = () => {
    mutation.mutate({
      id :+id,
      status: statusSelected,
      note,
    });
  };
  const isDisabled =()=>{
    return !(status)
  }
  const CloseIcon = icons.close;
  const NoteIcon = icons.abc;
  const status = ["approved ", "refused"];
  const handelChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    if (name === "status") {
      setStatus(value);
    } else {
      setNote(value);
    }
  };
  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تعديل حالة الطلب</h2>
        </div>
        <div className={classes.modalBody}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="">حالة الطلب</label>
              <select
                name="status"
                onChange={handelChange}
                className={classes.inputCustom}>
                <option value=" ">اختار الحالة</option>
                {status.map((item, i) => (
                  <option key={i} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            <div className={classes.formCol}>
              <label htmlFor="">الملاحظة</label>
              <textarea
                name="note"
                type="text"
                className={classes.inputCustom}
                onChange={handelChange}></textarea>
            </div>
          </div>
        </div>
        <div className={classes.modalFooter}>
          <button className="btn btn-primary" onClick={handlePostRequest}  disabled={isDisabled()}>
            تأكيد
          </button>
          <button className="btn btn-danger" onClick={closeModal}>
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusModal;
